export default __webpack_public_path__ + "static/media/logo_PE.488ccdd4.svg";